/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Import_Already_RunningInputs */

const fr_api_import_already_running = /** @type {(inputs: Api_Import_Already_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un import est déjà en cours. Attendez sa fin.`)
};

const en_api_import_already_running = /** @type {(inputs: Api_Import_Already_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An import is already running. Wait for it to finish.`)
};

/**
* | output |
* | --- |
* | "An import is already running. Wait for it to finish." |
*
* @param {Api_Import_Already_RunningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_import_already_running = /** @type {((inputs?: Api_Import_Already_RunningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Import_Already_RunningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_import_already_running(inputs)
	return fr_api_import_already_running(inputs)
});